import LabelMap from "../../../bootstrap/types/label-map/LabelMap";
import __ from "../../i18n";


export const TYPE_RADIO_BUTTONS = 'RADIO_BUTTONS';
export const TYPE_CHECKBOXES = 'CHECKBOXES';
export const TYPE_TEXT_COMPLETION = 'TEXT_COMPLETION';
export const TYPE_WORD_ARRANGEMENT = 'WORD_ARRANGEMENT';

export default new LabelMap([
    [TYPE_RADIO_BUTTONS, __('Radio Buttons')],
    [TYPE_CHECKBOXES, __('Checkboxes')],
    [TYPE_TEXT_COMPLETION, __('Text Completion')],
    [TYPE_WORD_ARRANGEMENT, __('Word Arrangement')],
]);
